module.exports = __webpack_public_path__ + "img/root-canal-treatment.5b7625d1.jpg";